import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cardr",
  "use": "icon-cardr-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cardr\"><defs><style type=\"text/css\"></style></defs><path d=\"M752.96 514.368a8 8 0 0 0 0-12.608L611.264 389.76a8 8 0 0 0-12.864 6.272v73.92H259.968a8 8 0 0 0-8 8v59.968c0 4.416 3.584 8 8 8h338.304v74.112c0 6.72 7.68 10.432 12.928 6.336l141.76-112z\" p-id=\"1510\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol